import Link from 'next/link';
import React from 'react';

const BookItem = ({
                    data,
                    classes = 'grid grid-cols-1 gap-[1.875rem] sm:grid-cols-3 md:grid-cols-4',
                  }) => {
  return (
    <>
      <div className={classes}>
        {data.map((item) => {
          const {id, image, title, author} = item;
          return (
            <article key={id}>
              <div className="rounded-2xl overflow-hidden transition-shadow hover:shadow-lg rounded-b-[1.25rem] ">
                <figure className="group overflow-hidden ">
                  <Link href={`/books/${id}`}>

                    <img
                      src={image}
                      alt={title}
                      className="h-full w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105 "
                    />

                  </Link>
                </figure>

                {/* <!-- Body --> */}
                <div className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-[1.25rem] border-t-0 bg-white p-[10%]">
                  {/* <!-- Meta --> */}
                  <h2 className="font-display text-jacarta-700 dark:hover:text-accent hover:text-accent mb-4 text-xl dark:text-white">
                    <Link href={`/books/${id}`}>
                       {title} 
                    </Link>
                  </h2>
                  <p className="dark:text-jacarta-60">{author}</p>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </>
  );
};

export default BookItem;
